<script lang="ts">
	import MetaHead from '$lib/components/MetaHead.svelte';
	import { openCalendly } from '$lib/utils.js';

	let { data } = $props();

	// Form state
	let name = $state('');
	let email = $state('');
	let subject = $state('');
	let message = $state('');
	let loading = $state(false);
	let status = $state<'idle' | 'success' | 'error'>('idle');
	let errorMessage = $state('');

	const subjects = [
		'Développement web / application',
		'Audit technique',
		'Mentorat / formation',
		'Partenariat / collaboration',
		'Autre'
	];

	const socials = [
		{
			label: 'LinkedIn',
			href: 'https://linkedin.com/in/juslin',
			icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>`
		},
		{
			label: 'GitHub',
			href: 'https://github.com/juslin03',
			icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/></svg>`
		},
		{
			label: 'Twitter / X',
			href: 'https://x.com/misterjuslin',
			icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>`
		},
		{
			label: 'WhatsApp',
			href: 'https://wa.me/+2250759842878',
			icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`
		}
	];

	async function handleSubmit(e: Event) {
		e.preventDefault();
		loading = true;
		status = 'idle';
		errorMessage = '';

		try {
			const res = await fetch('/api/contact', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ name, email, subject, message })
			});

			const json = await res.json();

			if (res.ok) {
				status = 'success';
				name = '';
				email = '';
				subject = '';
				message = '';
			} else {
				status = 'error';
				errorMessage = json.error ?? 'Une erreur est survenue. Réessayez.';
			}
		} catch {
			status = 'error';
			errorMessage = 'Impossible de joindre le serveur. Vérifiez votre connexion.';
		} finally {
			loading = false;
		}
	}
</script>

<MetaHead {data} />

<!-- HERO -->
<section class="relative overflow-hidden px-4 py-20">
	<!-- Background décoratif -->
	<div class="pointer-events-none absolute inset-0 -z-10">
		<div
			class="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-primary/10 blur-3xl dark:bg-primary/5"
		></div>
		<div
			class="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-primary/5 blur-3xl dark:bg-primary/5"
		></div>
	</div>

	<div class="mx-auto max-w-3xl text-center">
		<span
			class="mb-4 inline-block rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary dark:bg-primary/20"
		>
			Contact
		</span>
		<h1 class="mb-4 text-4xl font-bold text-gray-900 md:text-5xl dark:text-white">
			Parlons de votre projet
		</h1>
		<p class="mx-auto max-w-xl text-lg text-gray-600 dark:text-gray-400">
			Une idée, un projet, une question ? Je réponds sous <strong
				class="text-gray-900 dark:text-white">24h ouvrées</strong
			>. Ou réservez directement un diagnostic gratuit de 30 minutes.
		</p>

		<!-- CTA diagnostic -->
		<div class="mt-8">
			<button
				onclick={openCalendly}
				class="inline-flex cursor-pointer items-center gap-2 rounded-xl bg-primary px-6 py-3 font-semibold text-white transition-all hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/20"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="18"
					height="18"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
					stroke-width="2"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
					/>
				</svg>
				Réserver un diagnostic gratuit — 30 min
			</button>
			<p class="mt-2 text-xs text-gray-400 dark:text-gray-500">Zéro engagement · 100% visio</p>
		</div>
	</div>
</section>

<!-- DIVIDER -->
<div class="mx-auto max-w-4xl px-4">
	<div class="flex items-center gap-4">
		<div class="h-px flex-1 bg-gray-200 dark:bg-gray-800"></div>
		<span class="text-sm text-gray-400 dark:text-gray-500">ou envoyez un message</span>
		<div class="h-px flex-1 bg-gray-200 dark:bg-gray-800"></div>
	</div>
</div>

<!-- MAIN CONTENT : infos + formulaire -->
<section class="mx-auto max-w-4xl px-4 py-12">
	<div class="grid gap-12 lg:grid-cols-5">
		<!-- Colonne infos (2/5) -->
		<aside class="space-y-8 lg:col-span-2">
			<!-- Email direct -->
			<div>
				<h2
					class="mb-3 text-sm font-semibold tracking-widest text-gray-400 uppercase dark:text-gray-500"
				>
					Email
				</h2>
				<a
					href="mailto:contact@juslin.dev"
					class="group flex items-center gap-2 text-gray-900 transition-colors hover:text-primary dark:text-white dark:hover:text-primary"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="18"
						height="18"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						stroke-width="1.8"
						class="flex-shrink-0 text-primary"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
						/>
					</svg>
					<span class="font-medium">contact@juslin.dev</span>
				</a>
			</div>

			<!-- Localisation -->
			<div>
				<h2
					class="mb-3 text-sm font-semibold tracking-widest text-gray-400 uppercase dark:text-gray-500"
				>
					Localisation
				</h2>
				<div class="flex items-center gap-2 text-gray-700 dark:text-gray-300">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="18"
						height="18"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						stroke-width="1.8"
						class="flex-shrink-0 text-primary"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
						/>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
						/>
					</svg>
					<span>Abidjan, Côte d'Ivoire · Remote</span>
				</div>
			</div>

			<!-- Disponibilité -->
			<div>
				<h2
					class="mb-3 text-sm font-semibold tracking-widest text-gray-400 uppercase dark:text-gray-500"
				>
					Disponibilité
				</h2>
				<div class="flex items-center gap-2">
					<span class="relative flex h-2.5 w-2.5">
						<span
							class="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75"
						></span>
						<span class="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500"></span>
					</span>
					<span class="text-sm font-medium text-gray-700 dark:text-gray-300">
						Disponible pour de nouveaux projets
					</span>
				</div>
			</div>

			<!-- Réseaux sociaux -->
			<div>
				<h2
					class="mb-3 text-sm font-semibold tracking-widest text-gray-400 uppercase dark:text-gray-500"
				>
					Réseaux
				</h2>
				<div class="flex flex-wrap gap-2">
					{#each socials as social}
						<a
							href={social.href}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={social.label}
							class="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium
							       text-gray-700 transition-all hover:border-primary/40 hover:bg-primary/5 hover:text-primary
							       dark:border-gray-800 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-primary/40 dark:hover:text-primary"
						>
							{@html social.icon}
							{social.label}
						</a>
					{/each}
				</div>
			</div>

			<!-- Temps de réponse -->
			<div
				class="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-900"
			>
				<div class="flex items-start gap-3">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="18"
						height="18"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						stroke-width="1.8"
						class="mt-0.5 flex-shrink-0 text-primary"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
						/>
					</svg>
					<div>
						<p class="text-sm font-medium text-gray-900 dark:text-white">Réponse sous 24h</p>
						<p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
							En jours ouvrés. Les weekends, je réponds le lundi.
						</p>
					</div>
				</div>
			</div>
		</aside>

		<!-- Formulaire (3/5) -->
		<div class="lg:col-span-3">
			<div
				class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm md:p-8 dark:border-gray-800 dark:bg-gray-900"
			>
				{#if status === 'success'}
					<!-- Succès -->
					<div class="flex flex-col items-center justify-center py-12 text-center">
						<div
							class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="28"
								height="28"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								stroke-width="2"
								class="text-green-600 dark:text-green-400"
							>
								<path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
							</svg>
						</div>
						<h3 class="mb-2 text-xl font-bold text-gray-900 dark:text-white">Message envoyé !</h3>
						<p class="text-gray-600 dark:text-gray-400">
							Je vous répondrai sous 24h ouvrées. À très bientôt.
						</p>
						<button
							onclick={() => (status = 'idle')}
							class="mt-6 text-sm font-medium text-primary underline underline-offset-4 hover:opacity-80"
						>
							Envoyer un autre message
						</button>
					</div>
				{:else}
					<form onsubmit={handleSubmit} class="space-y-5" novalidate>
						<div class="grid gap-5 sm:grid-cols-2">
							<!-- Nom -->
							<div>
								<label
									for="name"
									class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
								>
									Nom complet <span class="text-red-500">*</span>
								</label>
								<input
									id="name"
									type="text"
									bind:value={name}
									required
									placeholder="Votre nom"
									class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900
									       placeholder-gray-400 transition-all outline-none
									       focus:border-primary focus:ring-2 focus:ring-primary/20
									       dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
								/>
							</div>

							<!-- Email -->
							<div>
								<label
									for="email"
									class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
								>
									Email <span class="text-red-500">*</span>
								</label>
								<input
									id="email"
									type="email"
									bind:value={email}
									required
									placeholder="vous@exemple.com"
									class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900
									       placeholder-gray-400 transition-all outline-none
									       focus:border-primary focus:ring-2 focus:ring-primary/20
									       dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
								/>
							</div>
						</div>

						<!-- Sujet -->
						<div>
							<label
								for="subject"
								class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
							>
								Sujet <span class="text-red-500">*</span>
							</label>
							<select
								id="subject"
								bind:value={subject}
								required
								class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900
								       transition-all outline-none
								       focus:border-primary focus:ring-2 focus:ring-primary/20
								       dark:border-gray-700 dark:bg-gray-800 dark:text-white"
							>
								<option value="" disabled selected>Choisissez un sujet</option>
								{#each subjects as s}
									<option value={s}>{s}</option>
								{/each}
							</select>
						</div>

						<!-- Message -->
						<div>
							<label
								for="message"
								class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
							>
								Message <span class="text-red-500">*</span>
							</label>
							<textarea
								id="message"
								bind:value={message}
								required
								rows={5}
								placeholder="Décrivez votre projet ou votre question en quelques lignes..."
								class="w-full resize-none rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900
								       placeholder-gray-400 transition-all outline-none
								       focus:border-primary focus:ring-2 focus:ring-primary/20
								       dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
							></textarea>
						</div>

						<!-- Erreur -->
						{#if status === 'error'}
							<div
								class="flex items-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-800 dark:bg-red-900/20 dark:text-red-400"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									stroke-width="2"
									class="flex-shrink-0"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
									/>
								</svg>
								{errorMessage}
							</div>
						{/if}

						<!-- Submit -->
						<button
							type="submit"
							disabled={loading}
							class="flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-6 py-3 font-semibold
							       text-white transition-all hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/20
							       disabled:cursor-not-allowed disabled:opacity-60"
						>
							{#if loading}
								<svg
									class="h-4 w-4 animate-spin"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
								>
									<circle
										class="opacity-25"
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="4"
									></circle>
									<path
										class="opacity-75"
										fill="currentColor"
										d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
									></path>
								</svg>
								Envoi en cours…
							{:else}
								Envoyer le message
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									stroke-width="2"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M17 8l4 4m0 0l-4 4m4-4H3"
									/>
								</svg>
							{/if}
						</button>

						<p class="text-center text-xs text-gray-400 dark:text-gray-500">
							Vos données ne sont jamais partagées avec des tiers.
						</p>
					</form>
				{/if}
			</div>
		</div>
	</div>
</section>
